import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  RecipesTranslationSectionComponent,
  TranslationLang,
} from '@recipes/recipes-translation/recipes-translation-section/recipes-translation-section.component';
import { RecipesTranslationFieldsContainerComponent } from '@recipes/recipes-translation/recipes-translation-fields-container/recipes-translation-fields-container.component';
import { RecipesTranslationInputFieldsComponent } from '@recipes/recipes-translation/recipes-translation-input-fields/recipes-translation-input-fields.component';
import { NgIf } from '@angular/common';
import { RecipeTranslationTitles } from '@shared/models/recipe/recipes-translation-form.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-recipes-translation-titles-section',
  imports: [
    RecipesTranslationSectionComponent,
    RecipesTranslationFieldsContainerComponent,
    RecipesTranslationInputFieldsComponent,
    NgIf,
    TranslateModule,
  ],
  templateUrl: './recipes-translation-titles-section.component.html',
  styleUrls: ['./recipes-translation-titles-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecipesTranslationTitlesSectionComponent {
  @Input() lang: TranslationLang;
  @Input() domain: string;
  @Input() sourceTitlesFg: FormGroup<RecipeTranslationTitles>;
  @Input() targetTitlesFg: FormGroup<RecipeTranslationTitles>;

  readonly COOKEO_DOMAIN = 'PRO_COO';
}
